export interface ApiError {
    kind: 'network' | 'authentication' | 'validation' | 'server' | 'unknown';
    status?: number;
    message: string;
    errors: string[];
}

function record(value: unknown): Record<string, unknown> {
    return value !== null && typeof value === 'object' ? value as Record<string, unknown> : {};
}

export function normalizeApiError(error: unknown): ApiError {
    const source = record(error);
    if (isApiError(error)) return error;
    const response = record(source.response);
    const status = typeof response.status === 'number' ? response.status
        : typeof source.status === 'number' ? source.status : undefined;
    const data = record(response.data ?? source.data);
    const errors = Object.values(record(data.errors)).flatMap(value =>
        Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string')
            : typeof value === 'string' ? [value] : []);
    const kind = status === 401 || status === 403 ? 'authentication'
        : status === 400 ? 'validation'
        : status !== undefined ? 'server'
        : source.isAxiosError === true || source.request ? 'network' : 'unknown';
    return {
        kind, status, errors,
        message: errors[0] ?? (typeof data.title === 'string' ? data.title
            : kind === 'network' ? 'Unable to connect. Please try again.'
            : 'The request could not be completed. Please try again.')
    };
}

export function isApiError(error: unknown): error is ApiError {
    const value = record(error);
    return ['network', 'authentication', 'validation', 'server', 'unknown'].includes(String(value.kind))
        && typeof value.message === 'string' && Array.isArray(value.errors);
}
